const pad = (n, width) => String(n).padStart(Math.max(1, Number(width) || 4), "0");

const fyStart = (d) => (d.getMonth() + 1 >= 4 ? d.getFullYear() : d.getFullYear() - 1);

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

// Mirrors backend/numbering.py render_number
export const renderNumber = ({ pattern, prefix, padding, sequence, on = new Date() }) => {
  const fy = fyStart(on);
  return (pattern || "{prefix}{seq}")
    .replaceAll("{prefix}", prefix || "")
    .replaceAll("{yyyy}", String(on.getFullYear()))
    .replaceAll("{yy}", pad(on.getFullYear() % 100, 2))
    .replaceAll("{mm}", pad(on.getMonth() + 1, 2))
    .replaceAll("{mon}", MONTHS[on.getMonth()])
    .replaceAll("{fy}", `${pad(fy % 100, 2)}-${pad((fy + 1) % 100, 2)}`)
    .replaceAll("{seq}", pad(sequence || 1, padding))
    .trim();
};

const TOKENS = ["{prefix}", "{seq}", "{yyyy}", "{yy}", "{mm}", "{mon}", "{fy}"];

export const unknownTokens = (pattern) =>
  [...String(pattern || "").matchAll(/\{[^}]*\}/g)]
    .map((m) => m[0])
    .filter((t) => !TOKENS.includes(t));

export const NUMBER_PRESETS = [
  { label: "INV-0001", pattern: "{prefix}{seq}" },
  { label: "INV-2026-0001", pattern: "{prefix}{yyyy}-{seq}" },
  { label: "INV-2026-06-0001", pattern: "{prefix}{yyyy}-{mm}-{seq}" },
  { label: "INV-26-27/0001", pattern: "{prefix}{fy}/{seq}" },
  { label: "INV-JUN26-0001", pattern: "{prefix}{mon}{yy}-{seq}" },
];

export const RESET_OPTIONS = [
  { value: "never", label: "Never — one running series" },
  { value: "monthly", label: "Every month" },
  { value: "yearly", label: "Every calendar year (1 January)" },
  { value: "financial", label: "Every financial year (1 April)" },
];
